{
  "name": "12-Septimal Blues",
  "description": "12-tone Septimal-Tertial Rational Intonation Blues scale, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, and 7, combined with 5-Limit triads on F, C and G.",
  "scale": [
    "49/48",
    "9/8",
    "7/6",
    "5/4",
    "4/3",
    "49/36",
    "3/2",
    "14/9",
    "5/3",
    "7/4",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-JI-7L-blues",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "G", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ff9b9b",
    "#f8c9c9",
    "#ffffff",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#f8c9c9",
    "#ffffff",
    "#ffe5e5",
    "#fffae5",
    "#ffe5e5",
    "#fffae5"
  ],
  "equivSteps": 12,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
